import { motion } from "framer-motion";
import { getSmsHref, handleSmsClick } from "@/lib/contact";
import {
  Briefcase,
  Church,
  PartyPopper,
  Plane,
  Palmtree,
} from "lucide-react";

const SERVICES = [
  {
    icon: PartyPopper,
    title: "Imprezy i uroczystości",
    items: [
      "Wesela — pozostajemy do dyspozycji Pary Młodej w ustalonych godzinach",
      "Urodziny, domówki i transport gości",
      "Wieczory kawalerskie i panieńskie",
      "Chrzciny, przyjęcia i inne imprezy okolicznościowe",
    ],
    testId: "service-card-imprezy",
  },
  {
    icon: Plane,
    title: "Lotniska",
    items: [
      "Transport na lotnisko o każdej porze",
      "Odbiór z lotniska — czekamy na Ciebie",
      "Pomoc z bagażem i komfortowa podróż",
    ],
    testId: "service-card-lotniska",
  },
  {
    icon: Briefcase,
    title: "Firmy i biznes",
    items: [
      "Transport na spotkania biznesowe i firmowe",
      "Przewozy pracownicze — stałe i jednorazowe",
      "Delegacje i wyjazdy służbowe",
    ],
    testId: "service-card-firmy",
  },
  {
    icon: Church,
    title: "Codzienne przejazdy",
    items: [
      "Dojazd do lekarza i szpitala",
      "Transport do kościoła",
      "Przejazdy na cmentarz",
    ],
    testId: "service-card-codzienne",
  },
  {
    icon: Palmtree,
    title: "Dalsze wyjazdy",
    items: [
      "Przewóz do sanatorium",
      "Turnusy rehabilitacyjne",
      "Wczasy i wakacje — dowieziemy pod same drzwi",
    ],
    testId: "service-card-dalsze",
  },
];

export const Services = () => (
  <section id="uslugi" data-testid="services-section" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-36">
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    >
      <p className="mb-4 font-display text-xs font-semibold tracking-[0.3em] text-[#E2C792]">
        NASZE USŁUGI
      </p>
      <h2 className="max-w-2xl font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
        Dokąd chcesz, <span className="text-[#E2C792]">kiedy chcesz</span>
      </h2>
    </motion.div>

    <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-20 md:gap-6">
      {SERVICES.map((service, i) => (
        <motion.article
          key={service.title}
          data-testid={service.testId}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
          className={`group rounded-2xl border border-white/10 bg-[#141414] p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#E2C792]/40 md:p-10 ${
            i === 0 ? "sm:col-span-2 lg:col-span-1" : ""
          }`}
        >
          <div className="mb-7 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-[#E2C792]/30 bg-[#E2C792]/10 text-[#E2C792] transition-transform duration-300 group-hover:scale-110">
            <service.icon className="h-7 w-7" strokeWidth={1.8} />
          </div>
          <h3 className="font-display text-2xl font-bold tracking-tight text-white">
            {service.title}
          </h3>
          <ul className="mt-5 space-y-3">
            {service.items.map((item) => (
              <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/65">
                <span className="mt-[9px] h-1 w-1 shrink-0 rounded-full bg-[#E2C792]" />
                {item}
              </li>
            ))}
          </ul>
        </motion.article>
      ))}

      <motion.a
        href={getSmsHref()}
        onClick={handleSmsClick}
        data-testid="services-sms-card"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col justify-between rounded-2xl border border-[#E2C792]/40 bg-[#E2C792] p-8 text-[#0A0A0A] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#D1B273] active:scale-[0.98] md:p-10"
      >
        <h3 className="font-display text-2xl font-bold tracking-tight md:text-3xl">
          Nie znalazłeś swojej usługi?
        </h3>
        <p className="mt-4 text-sm leading-relaxed text-[#0A0A0A]/75">
          Zadzwoń lub napisz SMS — dopasujemy przejazd do Twoich potrzeb.
        </p>
        <span className="mt-8 inline-flex w-fit items-center gap-2 rounded-full border border-[#0A0A0A]/30 px-6 py-3 font-display text-sm font-bold tracking-wide">
          NAPISZ SMS
        </span>
      </motion.a>
    </div>
  </section>
);
